<div [ngSwitch]="kamonaFormButtonType">
	<div *ngSwitchCase="KamonaDialogButtonType.SINGLE">
		<ng-container *ngTemplateOutlet="singleBtn"></ng-container>
	</div>
	<div *ngSwitchCase="KamonaDialogButtonType.DOUBLE_BUTTON">
		<div nz-row nzJustify="end">
			<div nz-row nzAlign="middle" nzJustify="space-between">
				<div>
					<div (click)="close()" class="back-btn">
						{{closeBtn}}
					</div>
				</div>
				<div [style.padding-left.px]="spacing">
					<ng-container *ngTemplateOutlet="singleBtn"></ng-container>
				</div>
			</div>
		</div>
	</div>
</div>
<ng-template #singleBtn>
	<div class="single-btn">
		<div [ngClass]="{'desktop-button-wrapper':!isMobile, 'kamona-button-session':isMobile}" nz-row
			 nzJustify="center">
			<div nz-col nzSpan="24">
				<div [style.min-width.px]="minWidthSubmitBtn">
					<app-kamona-custom-button
						(submitForm)="submit()"
						[isBlock]="true"
						[isDisabled]="disableButton"
						[isSubmitting]="submitting || loading"
						[state]="'primary'" [text]="submitBtn">
					</app-kamona-custom-button>
				</div>
			</div>
		</div>
	</div>
</ng-template>

